import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { LoginService } from '@services/login/login.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalHttpErrorInterceptorService {
  private retryAttempts = 1;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private snackBar: SnackBarService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      retry(this.retryAttempts),
      catchError((error) => this.handleError(error))
    );
  }

  private handleError(error: any): Observable<never> {
    let errorMessage = '';

    // Manejo de errores específicos por código de estado
    switch (error.status) {
      case 400:
        errorMessage = 'El servidor no puede o no procesará la petición debido a un error.';
        break;
      case 401:
      case 403:
        this.loginService.logout();
        this.router.navigateByUrl('/login');
        errorMessage = 'Es necesario autenticar para obtener la respuesta solicitada.';
        break;
      case 404:
        errorMessage = 'El servidor no pudo encontrar el contenido solicitado.';
        break;
      case 500:
        errorMessage = 'El servidor ha encontrado una situación que no sabe cómo manejarla.';
        break;
      case 503:
        errorMessage = 'El servidor no está listo para manejar la petición. Podría estar caído por mantenimiento o sobrecargado.';
        break;
      case 504:
        errorMessage = 'Error de conexión. El servidor no pudo obtener una respuesta a tiempo.';
        break;
      default:
        errorMessage = 'Ups... hubo un problema en el sistema.';
        break;
    }

    // Si no hay un error detallado, establecer mensaje por defecto
    if (error.error) {
      errorMessage = error.error.failureReason || errorMessage;

      // Reemplazar errores comunes en las respuestas
      errorMessage = this.mapCommonErrors(errorMessage);
    }

    // Usar un servicio de notificaciones para informar al usuario
    this.snackBar.showError(errorMessage,'Atención');

    return throwError(() => new Error(errorMessage));
  }

  // Mapeo de errores comunes
  private mapCommonErrors(message: string): string {
    if (message.includes("REFERENCE 'FK")) return "El registro no se puede eliminar debido a referencias asociadas.";
    if (message.includes("Http failure response")) return "Error de conexión.";
    if (message.includes("A connection attempt failed")) return "La conexión falló porque la parte conectada no respondió.";
    if (message.includes("Sequence contains no elements")) return "La consulta no contiene elementos.";
    if (message.includes("Year, Month, and Day parameters describe an un-representable DateTime.")) return "Fecha no representable.";
    if (message.includes("Execution Timeout Expired")) return "Tiempo de espera expirado.";
    if (message.includes("An error occurred while updating the entries.")) return "Error al actualizar las entradas.";

    return message;
  }
}
